module.exports = __webpack_public_path__ + "img/MR.8dc5f263.svg";